import { Injectable } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

/**
 * This class acts as a holder of miscellaneous behavior
 * in order for widgets to interact with each other
 */
@Injectable()
export class BehaviorService {

    // START RENTAL INCOME BEHAVIOR - if add is passed, a new rental income is added to the FG
    static ADD_RENTAL_INCOME_BEHAVIOR = 'add';

    private rentalIncomeBehaviorSubject = new BehaviorSubject<String>(null);
    public rentalIncomeBehavior = this.rentalIncomeBehaviorSubject.asObservable();

    public triggerRentalIncomeBehavior(behavior: String) {
        this.rentalIncomeBehaviorSubject.next(behavior);
    }
    // END RENTAL INCOME BEHAVIOR

    // START RENTAL INVESTMENT BEHAVIOR - if add is passed, a new rental income is added to the FG
    private rentalInvestmentsUpdatedSubject = new BehaviorSubject<any>(null);
    public rentalInvestmentsUpdated = this.rentalInvestmentsUpdatedSubject.asObservable();

    private rentalInvestmentRemovedSubject = new BehaviorSubject<any>(null);
    public rentalInvestmentRemoved = this.rentalInvestmentRemovedSubject.asObservable();

    public triggerRentalInvestmentsUpdated(data: UntypedFormArray) {
      this.rentalInvestmentsUpdatedSubject.next(data);
    }

    public triggerRentalInvestmentsRemoved(link: String) {
      this.rentalInvestmentRemovedSubject.next(link);
    }
    // END RENTAL INVESTMENT BEHAVIOR

}

